import { getPerkIcon, mapPerkIconsToAllPerks } from './perkIcons.mjs';

// TODO: Comment disclaimers out for now.
// TODO: Check what disclaimers will look like (e.g., if they're included as part of `description`)
function mapPerkSection(perks, tokens, wscore) {
  const filteredPerks = perks.filter(p => p.primeTokens === tokens && p.wscore === wscore);

  // Assumes the first space delineates the amount and that disclaimers are separated by `<sup>*</sup> `
  const splitStr = (str, delimiter) => {
    const [first, ...last] = str.split(delimiter);
    return [first, last.join(delimiter)];
  };

  const noAmountHandler = (fullName) => {
    const defaultAmount = 'One ';
    let [amount, name] = splitStr(fullName, ' ');

    if (/\d/.test(amount)) {
      return [amount, name];
    }

    return [defaultAmount, fullName];
  };

  const mapPerksPerSection = (perks) => {
    return perks.map(perk => {
      let [amount, name] = noAmountHandler(perk.name);
      // let [frequency, disclaimer] = splitStr(perk.description, '<sup>*</sup> ');

      return {
        id: perk.primePerkId,
        fullName: perk.name,
        name,
        amount,
        // frequency,
        // disclaimer,
        description: perk.description,
        icon: getPerkIcon(perk.category),
      };
    });
  };

  return {
    required: {
      tokens,
      wscore,
    },
    perks: mapPerksPerSection(filteredPerks),
  };
}

export function mapPerks(perks) {
  const mappedPerkIcons = mapPerkIconsToAllPerks(perks);
  let sections = [...new Set(mappedPerkIcons.map(p => [p.primeTokens, p.wscore]))];
  sections = new Set(sections.map(JSON.stringify));
  sections = Array.from(sections).sort().map(JSON.parse);
  let mappedPerkSections = [];

  sections.forEach(([tokens, wscore]) => mappedPerkSections.push(mapPerkSection(perks, tokens, wscore)));

  return mappedPerkSections;
}
